import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProductModel} from '../../../../models/product.model';
import {SharedService} from '../../../../services/shared.service';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as _ from 'lodash';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {CalendarDialogComponent} from '../../../../components/calendar-dialog/calendar-dialog.component';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-fuel',
  templateUrl: './fuel.component.html',
  styleUrls: ['./fuel.component.scss']
})
export class FuelComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  products: Array<any> = [];
  selectedProduct: any;
  productForm: FormGroup;
  selectedHours: Array<string> = [];
  disabledHours: Array<string> = [];
  amount: number;
  dayHours: Array<any> = [
    {
      name: 'MORNING',
      short: 'morning'
    },
    {
      name: 'AFTERNOON',
      short: 'afternoon'
    },
    {
      name: 'EVENING',
      short: 'evening'
    }
  ];

  constructor(private shared: SharedService,
              private router: Router,
              private fb: FormBuilder,
              private dialog: MatDialog) {
    this.productForm = this.fb.group({
      amount: [null, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.min(10)]],
      fuelParent: [null, Validators.required],
      fuelTypeID: [null, Validators.required],
      name: [null, Validators.required],
      deliveryDate: [null, Validators.required],
      fillUp: [null, Validators.required]
    });
    this.shared.sendEvent({type: 'request_step', data: {step: 1, name: 'REQUEST.FUEL.NAME'}});
    this.shared.eventObservable
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => {
        if (event.type == 'delivery_date') {
          this.productForm.patchValue({deliveryDate: formatDate(event.data, 'MM/dd/yyyy', 'en-US')});
          this.selectedHours = [];
          if (event.data.getDate() == new Date().getDate()) {//If user selected today, check available hours
            let nowHour = new Date().getHours();
            this.disabledHours = [];
            if (nowHour > 10) this.disabledHours.push('morning');
            if (nowHour > 15) this.disabledHours.push('afternoon');
            if (nowHour > 20) this.disabledHours.push('evening');
          } else {
            this.disabledHours = [];
          }
        }
      });
    this.products = [
      {
        name: 'Dyed Diesel',
        short: 'dyedDiesel',
        children: [
          new ProductModel({id: '-Klt2WvPSvKMG6GyzW5K', name: 'Valvtect marine Diesel - Off Road', status: true}),
          new ProductModel({id: '-KlyKMPW1-cHa6N11thk', name: 'Red Dyed Diesel - Off Road', status: true})
        ]
      },
      {
        name: 'Rec 90',
        short: 'gasoline',
        children: [
          new ProductModel({id: '-Klt2NPhkv4KKxQMumQo', name: 'Rec 90 Marine Gasoline', status: true})
        ]
      }
    ];
  }

  productClassChecker(product) {
    let selector;
    if (this.selectedProduct) selector = 'hide';
    if (this.selectedProduct && this.selectedProduct.short == product.short) selector = 'active';
    return selector;
  }

  setSelectedProduct(product: any) {
    let timeOut = 20;
    if (product) timeOut = 1;
    setTimeout(() => {
      this.selectedProduct = product;
      if (product) {
        this.productForm.patchValue({fuelParent: product.short});
        if (product.children.length == 1) this.productForm.patchValue({fuelTypeID: product.children[0].id, name: product.children[0].name});
      } else {
        this.selectedHours = [];
        this.disabledHours = [];
        this.amount = null;
        this.productForm.reset();
      }
    }, timeOut);
  }

  selectDate() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {date: this.productForm.value.deliveryDate};
    this.dialog.open(CalendarDialogComponent, dialogConfig);
  }

  selectFuelType(product: ProductModel) {
    if (product) this.productForm.patchValue({fuelTypeID: product.id, name: product.name});
    else this.productForm.patchValue({fuelTypeID: null, name: null});
  }

  selectHour(selected) {
    if (selected == 'all') {
      let all = ['morning', 'afternoon', 'evening'];
      this.selectedHours = _.difference(all, this.disabledHours);
    } else if (this.disabledHours.indexOf(selected) == -1) {
      if (this.selectedHours.indexOf(selected) != -1) this.selectedHours.splice(this.selectedHours.indexOf(selected), 1);
      else this.selectedHours.push(selected);
    }

  }

  amountChange(event) {
    if (event.target.value) {
      this.amount = parseInt(event.target.value);
      this.productForm.patchValue({amount: parseInt(event.target.value)});
    }
    else this.productForm.patchValue({amount: null});
  }

  submitStep() {
    //Process data before next step
    if (this.productForm.valid) {
      let d = this.productForm.value;
      let orderUpdates = {
        deliveryDate: d.deliveryDate,
        specs: {
          product: {
            amount: d.amount.toString(),
            fuelParent: d.fuelParent,
            fuelTypeID: d.fuelTypeID,
            name: d.name,
          },
          recipient: {
            fillUp: d.fillUp
          }
        },
        selectedHours: {
          afternoon: this.selectedHours.indexOf('afternoon') != -1,
          evening: this.selectedHours.indexOf('evening') != -1,
          morning: this.selectedHours.indexOf('morning') != -1,
          overnight: false
        }
      };
      this.shared.addRescheduleOrder(null);
      this.shared.setOrder(orderUpdates, 'recipient');
      return this.router.navigate(['account', 'request', 'recipient']);
    }

  }

  setFillUp(fill) {
    this.productForm.patchValue({fillUp: fill});
  }

  checkAmount() {
    let amount = parseInt(this.productForm.value.amount);
    if (amount < 10) this.shared.openErrorDialog({title: 'Error', body: 'Please enter amount of 10 or more gallons'});
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
